import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
      <Topbar onMenuToggle={() => setMenuOpen(o => !o)} />
      <div className={`sidebar-backdrop${menuOpen ? ' visible' : ''}`} onClick={() => setMenuOpen(false)} />
      <div className="main-content">
        <div className="main-content-inner">
          <Outlet />
        </div>
      </div>
    </>
  );
}
